// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estils específics del Calendari laboral: graella de mesos i colors de
   festiu. Prefix "calendari-laboral-". El xassís (capçalera, botons, modal)
   és v2 (dv2-*). */

.calendari-laboral-selector-any {
  display: flex;
  align-items: center;
  gap: 8px;
}

.calendari-laboral-any {
  font-size: 18px;
  font-weight: 700;
  min-width: 52px;
  text-align: center;
}

.calendari-laboral-mesos {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
}

.calendari-laboral-mes {
  background-color: var(--dv2-surface, #ffffff);
  border: 1px solid var(--dv2-border, #ddd);
  border-radius: var(--dv2-radius, 8px);
  padding: 10px;
  box-shadow: var(--dv2-shadow, none);
}

.calendari-laboral-mes-titol {
  font-weight: 700;
  text-align: center;
  margin-bottom: 6px;
}

.calendari-laboral-dies-setmana,
.calendari-laboral-graella {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}

.calendari-laboral-dia-setmana {
  font-size: 11px;
  font-weight: 700;
  text-align: center;
  color: var(--dv2-text-muted, #777);
}

.calendari-laboral-dia {
  font-size: 12px;
  text-align: center;
  padding: 4px 0;
  border-radius: 4px;
  cursor: pointer;
}

.calendari-laboral-dia:hover {
  background-color: #e0e0e0;
}

.calendari-laboral-dia-buit {
  cursor: default;
}

.calendari-laboral-dia-buit:hover {
  background-color: transparent;
}

.calendari-laboral-dia-festiu {
  background-color: #d9534f;
  color: #ffffff;
  font-weight: 700;
}

.calendari-laboral-dia-festiu:hover {
  background-color: #c9302c;
}

.calendari-laboral-dia-empresa {
  background-color: #0099cc;
  color: #ffffff;
  font-weight: 700;
}

.calendari-laboral-dia-empresa:hover {
  background-color: #007ba3;
}

.calendari-laboral-error {
  color: var(--dv2-danger, #d9534f);
  font-weight: 700;
  margin: 8px 0 0;
}

.calendari-laboral-anuals {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 18px;
  margin: 0 0 4px;
  padding: 10px 14px;
  background-color: var(--dv2-surface, #fff);
  border: 1px solid var(--dv2-border, #ddd);
  border-radius: var(--dv2-radius, 8px);
  box-shadow: var(--dv2-shadow, none);
}

.calendari-laboral-anuals-item {
  font-size: 13px;
  white-space: nowrap;
}

.calendari-laboral-anuals-item strong {
  margin-left: 4px;
}

.calendari-laboral-anuals-horari {
  margin-left: auto;
  font-size: 13px;
  white-space: nowrap;
}

.calendari-laboral-anuals-horari strong {
  margin-left: 4px;
}

.calendari-laboral-anuals-form {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 10px;
}

.calendari-laboral-anuals-form label {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.calendari-laboral-anuals-form .dv2-input {
  width: 90px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/calendarilaboral.css"],"names":[],"mappings":"AAAA;;mBAEmB;;AAEnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,6CAA6C;EAC7C,yCAAyC;EACzC,qCAAqC;EACrC,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,0CAA0C;EAC1C,yCAAyC;EACzC,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb","sourcesContent":["/* Estils específics del Calendari laboral: graella de mesos i colors de\n   festiu. Prefix \"calendari-laboral-\". El xassís (capçalera, botons, modal)\n   és v2 (dv2-*). */\n\n.calendari-laboral-selector-any {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.calendari-laboral-any {\n  font-size: 18px;\n  font-weight: 700;\n  min-width: 52px;\n  text-align: center;\n}\n\n.calendari-laboral-mesos {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 16px;\n}\n\n.calendari-laboral-mes {\n  background-color: var(--dv2-surface, #ffffff);\n  border: 1px solid var(--dv2-border, #ddd);\n  border-radius: var(--dv2-radius, 8px);\n  padding: 10px;\n  box-shadow: var(--dv2-shadow, none);\n}\n\n.calendari-laboral-mes-titol {\n  font-weight: 700;\n  text-align: center;\n  margin-bottom: 6px;\n}\n\n.calendari-laboral-dies-setmana,\n.calendari-laboral-graella {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px;\n}\n\n.calendari-laboral-dia-setmana {\n  font-size: 11px;\n  font-weight: 700;\n  text-align: center;\n  color: var(--dv2-text-muted, #777);\n}\n\n.calendari-laboral-dia {\n  font-size: 12px;\n  text-align: center;\n  padding: 4px 0;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.calendari-laboral-dia:hover {\n  background-color: #e0e0e0;\n}\n\n.calendari-laboral-dia-buit {\n  cursor: default;\n}\n\n.calendari-laboral-dia-buit:hover {\n  background-color: transparent;\n}\n\n.calendari-laboral-dia-festiu {\n  background-color: #d9534f;\n  color: #ffffff;\n  font-weight: 700;\n}\n\n.calendari-laboral-dia-festiu:hover {\n  background-color: #c9302c;\n}\n\n.calendari-laboral-dia-empresa {\n  background-color: #0099cc;\n  color: #ffffff;\n  font-weight: 700;\n}\n\n.calendari-laboral-dia-empresa:hover {\n  background-color: #007ba3;\n}\n\n.calendari-laboral-error {\n  color: var(--dv2-danger, #d9534f);\n  font-weight: 700;\n  margin: 8px 0 0;\n}\n\n.calendari-laboral-anuals {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 18px;\n  margin: 0 0 4px;\n  padding: 10px 14px;\n  background-color: var(--dv2-surface, #fff);\n  border: 1px solid var(--dv2-border, #ddd);\n  border-radius: var(--dv2-radius, 8px);\n  box-shadow: var(--dv2-shadow, none);\n}\n\n.calendari-laboral-anuals-item {\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.calendari-laboral-anuals-item strong {\n  margin-left: 4px;\n}\n\n.calendari-laboral-anuals-horari {\n  margin-left: auto;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.calendari-laboral-anuals-horari strong {\n  margin-left: 4px;\n}\n\n.calendari-laboral-anuals-form {\n  display: flex;\n  align-items: flex-end;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.calendari-laboral-anuals-form label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.calendari-laboral-anuals-form .dv2-input {\n  width: 90px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
